import {
  gsapWithCSS
} from "./chunk.LXB4MYP4.js";
import {
  ae
} from "./chunk.Q25FCJRM.js";
import {
  Spaceable
} from "./chunk.G3SZKTQJ.js";
import {
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.ABOYTYJO.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  h,
  ke
} from "./chunk.FCKNEYTX.js";
import {
  e,
  n,
  r as r2
} from "./chunk.BBN2ZB42.js";
import {
  i,
  r
} from "./chunk.FAJKIEWS.js";
import {
  __decorateClass
} from "./chunk.I4IFG4JG.js";

// src/components/jb-publication-download/jb-publication-download.scss?inline
var jb_publication_download_default = i`*,
*::before,
*::after {
  box-sizing: border-box;
}

div,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
ol,
ul,
li,
form,
legend,
label,
table,
header,
footer,
nav,
section,
figure {
  margin: 0;
  padding: 0;
}

a {
  color: inherit;
}

/* COLOR SETTINGS */
/* shadows */
:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
/* stylelint-disable */
/* stylelint-enable */
h2 {
  font-family: var(--theme-font-light-family, VerlagSSm, Tahoma, sans-serif);
  font-style: normal;
  font-weight: var(--theme-font-light-weight, 300);
}

h2 {
  font-size: var(--theme-typo-h2-subtitle-mobile-fontsize, 1.625rem);
  line-height: var(--theme-typo-h2-subtitle-mobile-lineheight, 2.188rem);
}
@media (min-width: 1281px) {
  h2 {
    font-size: var(--theme-typo-h2-subtitle-desktop-fontsize, 1.938rem);
    line-height: var(--theme-typo-h2-subtitle-desktop-lineheight, 2.625rem);
  }
}

:host {
  --spacing-none: 0;
  --spacing-base: 4px;
  --spacing-3xs: 8px;
  --spacing-2xs: 12px;
  --spacing-xs: 16px;
  --spacing-s: 20px;
  --spacing-sm: 20px;
  --spacing-m: 24px;
  --spacing-lm: 28px;
  --spacing-l: 32px;
  --spacing-xl: 32px;
  --spacing-2xl: 36px;
  --spacing-3xl: 36px;
  --spacing-4xl: 72px;
  --spacing-small: var(--spacing-lm);
  --spacing-medium: var(--spacing-3xl);
  --spacing-big: var(--spacing-4xl);
  --spacing-gap: 16px;
}

@media screen and (width >= 1281px) {
  :host {
    --spacing-sm: 24px;
    --spacing-m: 32px;
    --spacing-lm: 36px;
    --spacing-l: 40px;
    --spacing-xl: 48px;
    --spacing-2xl: 64px;
    --spacing-3xl: 72px;
    --spacing-4xl: 144px;
    --spacing-small: var(--spacing-lm);
    --spacing-medium: var(--spacing-3xl);
    --spacing-big: var(--spacing-4xl);
    --spacing-gap: 40px;
  }
}
/* special measurements */
:host {
  color: var(--host-color, #141e55);
}

:host {
  display: inline-block;
  width: 100%;
}

:host(.in-overlay) {
  margin-block-start: 16px;
}
@media (min-width: 960px) {
  :host(.in-overlay) .image-wrapper {
    box-sizing: border-box;
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    padding: 0 20px;
    width: 41.6666666667%;
    margin: 0 0 0 8.33%;
  }
}
:host(.in-overlay) .content-wrapper {
  margin-block-end: 48px;
}

section {
  box-sizing: border-box;
  display: flex;
  flex: 0 1 auto;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: auto;
  width: calc(100% - 2 * var(--row-small-margin, 6.68%));
}
@media (min-width: 600px) and (max-width: 959px) {
  section {
    width: calc(100% - 2 * 8.35%);
  }
}
@media (min-width: 1437px) {
  section {
    max-width: var(--row-max-width, 1436px);
  }
  section:not(.filtered-list) {
    width: 100%;
  }
}
@media only screen and (min-width: 960px) and (max-width: 1436px) {
  section {
    margin: 0 6.955%;
    max-width: calc(100% - 6.955% - 6.955%);
  }
}
@media (min-width: 960px) {
  section {
    box-sizing: border-box;
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    flex-wrap: wrap;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    box-sizing: border-box;
    flex-basis: 100%;
    max-width: 100%;
    padding: 0 0;
    width: 100%;
  }
}

div {
  transition: background-color 0.8s linear;
}

.image-wrapper {
  box-sizing: border-box;
  flex-basis: 75%;
  max-width: 75%;
  padding: 0 0;
  width: 75%;
  margin: 0 auto;
}
@media (min-width: 960px) {
  .image-wrapper {
    box-sizing: border-box;
    flex-basis: 25%;
    max-width: 25%;
    padding: 0 20px;
    width: 25%;
    margin: 0 0 0 16.67%;
  }
}

.content-wrapper {
  box-sizing: border-box;
  flex-basis: 100%;
  max-width: 100%;
  padding: 0 0;
  width: 100%;
  margin-block-start: 28px;
}
@media (min-width: 960px) {
  .content-wrapper {
    box-sizing: border-box;
    flex-basis: 41.6666666667%;
    max-width: 41.6666666667%;
    padding: 0 20px;
    width: 41.6666666667%;
    margin-block-start: 0;
  }
}

jb-button-primary {
  padding-block-start: 30px;
}
@media (max-width: 599px) {
  jb-button-primary {
    width: 100%;
  }
}

jb-feature-list {
  display: block;
  margin-block-start: var(--spacing-2xs);
}

jb-feature-list + jb-form {
  margin-block-start: 0;
}

jb-form {
  margin-block-start: 14px;
}
jb-form jb-button-primary {
  padding-block-start: unset;
}

jb-picture {
  background-color: rgba(0, 0, 0, 0.063);
  box-shadow: 0 5px 20px 0 rgba(0, 0, 0, 0.1);
  margin-block-end: 20px;
}
@media (min-width: 960px) {
  jb-picture {
    margin-block-end: 0;
  }
}

h2 {
  margin-block-end: 34px;
}

.newsletter-page,
.success-page,
.error-page {
  display: none;
  opacity: 0;
}`;

// src/components/jb-publication-download/jb-publication-download.ts
var JbPublicationDownload = class extends Spaceable(h) {
  constructor() {
    super(...arguments);
    this.withNewsletterSignup = false;
    this._firstPartyDataProcessing = false;
    this._formSubmitted = false;
    this._formValid = false;
    this._textWithCountdown = "";
  }
  async firstUpdated() {
    await this.updateComplete;
    if (this.autoStartAfterSeconds) {
      let counter = this.autoStartAfterSeconds;
      this._textWithCountdown = this.texts.downloadText.replace("{counter}", String(counter));
      counter -= 1;
      const intervalId = setInterval(() => {
        this._textWithCountdown = this.texts.downloadText.replace("{counter}", String(counter));
        counter -= 1;
        if (counter < 0) {
          clearInterval(intervalId);
        }
      }, 1e3);
      setTimeout(() => {
        if (this._downloadButton) {
          this._downloadButton.triggerClick();
        }
      }, this.autoStartAfterSeconds * 1e3);
    }
    if (this.skipDownloadPage) {
      const targetPage = this.renderRoot.querySelector(".newsletter-page");
      if (targetPage) {
        const componentObserver = new IntersectionObserver(
          async (entries, observer) => {
            if (entries[0].isIntersecting) {
              this._dispatchFormOpenEvent();
              observer.disconnect();
            }
          },
          {
            rootMargin: "0px"
          }
        );
        componentObserver.observe(this);
        this.renderRoot.querySelectorAll(".page").forEach((element) => {
          element.style.display = "none";
          element.style.opacity = "0";
        });
        targetPage.style.display = "initial";
        targetPage.style.opacity = "1";
      }
    }
  }
  _captureTracking(evt) {
    evt.stopPropagation();
  }
  _dispatchFormOpenEvent() {
    this.parentElement?.dispatchEvent(
      new CustomEvent("jb-tracking", {
        detail: {
          component_name: "publication-download",
          event: "ce_form",
          event_version: "v2",
          form_step_name: "form open",
          form_step_nr: "1",
          form_subject: this.link?.data.downloadFileName,
          form_type: "newsletter"
        },
        bubbles: true,
        composed: true
      })
    );
  }
  _dispatchFormSentEvent() {
    const eventInitDict = {
      detail: {
        component_name: "publication-download",
        event: "ce_form",
        event_version: "v2",
        form_step_name: "form sent",
        form_step_nr: "2",
        form_subject: this.link?.data.downloadFileName,
        form_type: "newsletter",
        optin_type: "single"
      },
      bubbles: true,
      composed: true
    };
    if (this.withNewsletterSignup) {
      eventInitDict.detail.first_party_data_processing = this._firstPartyDataProcessing;
    }
    this.parentElement?.dispatchEvent(new CustomEvent("jb-tracking", eventInitDict));
  }
  _download(e2) {
    this._tracking(e2);
    if (this.clickCallbackUrl) {
      fetch(this.clickCallbackUrl);
    }
    if (this.withNewsletterSignup) {
      this._transitionTo(".download-page", ".newsletter-page");
      this._dispatchFormOpenEvent();
    }
    if (!this.withNewsletterSignup && !this.autoStartAfterSeconds) {
      this._transitionTo(".download-page", ".success-page");
    }
  }
  _getContentSpacingProperties() {
    const type = this.classList.contains("in-overlay") ? "no-vertical-space" : void 0;
    return { colsMdUp: "none", horizontal: "full-width", type };
  }
  _subscribe(e2) {
    e2.preventDefault();
    if (!this._formValid || this._formSubmitted) return;
    this._formSubmitted = true;
    const form = this.shadowRoot?.querySelector("jb-form");
    const slottedInputs = form.querySelectorAll("jb-text-field, jb-checkbox");
    const additionalInputs = form.shadowRoot?.querySelectorAll("input");
    const formData = {};
    if (globalThis._satellite) {
      formData.marketingCloudVisitorID = globalThis._satellite.getVisitorId().getMarketingCloudVisitorID();
      formData.marketingCloudOrgID = globalThis._satellite.getVisitorId().marketingCloudOrgID;
    }
    Array.from([...slottedInputs, ...additionalInputs]).forEach((element) => {
      try {
        const name = element.getAttribute("name");
        if (element.tagName === "JB-CHECKBOX") {
          formData[name] = element.checkbox?.checked;
        } else {
          formData[name] = element.value;
        }
      } catch (err) {
      }
    });
    try {
      this._firstPartyDataProcessing = formData.newsletterAgree;
    } catch (err) {
    }
    fetch(this.formAction, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      redirect: "follow",
      body: JSON.stringify(formData)
    }).then((response) => {
      if (!response.ok) {
        this._transitionTo(".newsletter-page", ".error-page");
      }
      return response.json();
    }).then((data) => {
      if (data.success === true) {
        this._transitionTo(".newsletter-page", data.success ? ".success-page" : ".error-page");
      } else {
        this._transitionTo(".newsletter-page", ".error-page");
      }
      if (data.success === true) {
        this._dispatchFormSentEvent();
      }
    });
  }
  _tracking(e2) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e2, {
      component_name: "publication-download"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  _transitionTo(page1, page2) {
    const el1 = this.renderRoot.querySelector(page1);
    const el2 = this.renderRoot.querySelector(page2);
    const timeline = gsapWithCSS.timeline({
      paused: true,
      defaults: { duration: 1 }
    }).to(el1, { opacity: 0, display: "none" }).to(el2, { display: "initial", opacity: 1 });
    timeline.restart();
  }
  render() {
    return ke`
      <section>
        <div class="image-wrapper">
          <jb-picture
            .alt=${this.picture.alt}
            .imgData=${this.picture.imgData}
            .lazy=${this.picture.lazy}
          ></jb-picture>
        </div>

        <div class="content-wrapper">
          <div class="download-page page">
            <h2>${this.texts.downloadTitle}</h2>
            <jb-richtext>${ae(this._textWithCountdown || this.texts.downloadText)}</jb-richtext>
            ${this.features ? ke` <jb-feature-list .features=${this.features}></jb-feature-list> ` : D}
            <jb-button-primary
              @jb-link:clicked=${this._download}
              .link=${this.link}
              data-download-button
            >
              ${this.texts.downloadButton}
            </jb-button-primary>
          </div>

          ${this.withNewsletterSignup ? ke`
                <div class="newsletter-page page">
                  <h2>${this.texts.downloadSuccessTitle}</h2>
                  <jb-richtext>${ae(this.texts.downloadSuccessText)}</jb-richtext>
                  ${this.features && this.skipDownloadPage ? ke` <jb-feature-list .features=${this.features}></jb-feature-list> ` : D}
                  <jb-form
                    action="/"
                    method="post"
                    formName="Newsletter Signup Form"
                    componentName="publication-download"
                    @jb-form:submit=${(e2) => {
      e2.detail.preventDefault();
      this._formValid = true;
      this._subscribe(e2);
    }}
                    @jb-tracking=${this._captureTracking}
                  >
                    <jb-text-field
                      requiredText=${this.texts.emailError}
                      emailErrorText=${this.texts.emailError}
                      label=${this.texts.emailPlaceholder}
                      name="email"
                      placeholder=${this.texts.emailPlaceholder}
                      type="email"
                    ></jb-text-field>
                    ${this.texts.agreement ? ke`
                          <jb-checkbox
                            afterCheckboxText=${this.texts.afterCheckboxText}
                            beforeCheckboxText=${this.texts.beforeCheckboxText}
                            requiredText=${this.texts.agreementRequiredText}
                            label=${this.texts.agreement}
                            name="newsletterAgree"
                            value="accepted"
                          ></jb-checkbox>
                        ` : D}
                    ${!this.texts.agreementRequiredText && this.texts.agreement && !this.withNewsletterSignup ? ke`
                          <jb-richtext .size=${"mini"}>
                            <p>${ae(this.texts.agreement)}</p>
                          </jb-richtext>
                        ` : D}
                    <jb-button-primary
                      @click=${this._subscribe}
                      name="submit"
                    >
                      ${this.texts.subscribeButton}
                    </jb-button-primary>
                  </jb-form>
                </div>
                <div class="success-page page">
                  <h2>
                    ${this.withNewsletterSignup && this.texts.successWithSubscriptionTitle && this._firstPartyDataProcessing ? ae(this.texts.successWithSubscriptionTitle) : ae(this.texts.successTitle)}
                  </h2>
                  <jb-richtext>
                    ${this.withNewsletterSignup && this.texts.successWithSubscriptionText && this._firstPartyDataProcessing ? ae(this.texts.successWithSubscriptionText) : ae(this.texts.successText)}
                  </jb-richtext>
                </div>

                <div class="error-page page">
                  <h2>${ae(this.texts.errorTitle)}</h2>
                  <jb-richtext>${ae(this.texts.errorText)}</jb-richtext>
                </div>
              ` : ke`
                <div class="success-page page">
                  <h2>${this.texts.downloadSuccessTitle}</h2>
                  <jb-richtext>${ae(this.texts.downloadSuccessText)}</jb-richtext>
                </div>
              `}
        </div>
      </section>
    `;
  }
};
JbPublicationDownload.styles = r(jb_publication_download_default);
__decorateClass([
  n({ type: Number })
], JbPublicationDownload.prototype, "autoStartAfterSeconds", 2);
__decorateClass([
  n()
], JbPublicationDownload.prototype, "clickCallbackUrl", 2);
__decorateClass([
  n({ type: Array })
], JbPublicationDownload.prototype, "features", 2);
__decorateClass([
  n()
], JbPublicationDownload.prototype, "formAction", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownload.prototype, "link", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownload.prototype, "picture", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "skipDownloadPage", 2);
__decorateClass([
  n({ type: Object })
], JbPublicationDownload.prototype, "texts", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "withNewsletterSignup", 2);
__decorateClass([
  e("[data-download-button]")
], JbPublicationDownload.prototype, "_downloadButton", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "_firstPartyDataProcessing", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "_formSubmitted", 2);
__decorateClass([
  n({ type: Boolean })
], JbPublicationDownload.prototype, "_formValid", 2);
__decorateClass([
  r2()
], JbPublicationDownload.prototype, "_textWithCountdown", 2);
JbPublicationDownload = __decorateClass([
  customElement("jb-publication-download")
], JbPublicationDownload);

export {
  JbPublicationDownload
};
